export function floatNumber(array) {
    let count = 0;
    array.forEach(resValue => {
        if (typeof resValue === 'number' && resValue !== 0) {
            count ++;
        }
    });
    return count;
}